import InvoiceDataList from "./new-invoice-data-lists";
 
const InvoiceDetails = (props: any) => {
  // Directly access the orderinfo from props
  const orderInfo = props.orderData?.props?.orderinfo;
  
  // Directly access the invoice data from orderinfo
  const invoiceData = orderInfo?.invoices || [];
 
  return (
    <>
      {/* Render InvoiceDataList only if there are invoices */}
      {invoiceData.length > 0 ? (
        <InvoiceDataList invoiceData={invoiceData} orderData={orderInfo} />
      ) : null}
    </>
  );
};
 
export default InvoiceDetails;